import { render, staticRenderFns } from "./aCarDetailOwner.vue?vue&type=template&id=51c745b0&scoped=true"
import script from "./aCarDetailOwner.vue?vue&type=script&lang=js"
export * from "./aCarDetailOwner.vue?vue&type=script&lang=js"
import style0 from "./aCarDetailOwner.vue?vue&type=style&index=0&id=51c745b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c745b0",
  null
  
)

export default component.exports